import { CSRFTokenPayload } from 'models/endpoints-payload'
import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_WT: string
declare const BIZ_BASE_URL_WT: string

export const getCsrfToken = (): Promise<string> => {
  return promiseWrapper<string, CSRFTokenPayload>(`${USER_BASE_URL_WT}/api/public/csrf-token`, 'GET', undefined, {
    withCredentials: true,
    contentType: 'text/plain',
  })
}

export const getCsrfTokenBiz = (): Promise<string> => {
  return promiseWrapper<string, CSRFTokenPayload>(`${BIZ_BASE_URL_WT}/api/public/csrf-token`, 'GET', undefined, {
    withCredentials: true,
    contentType: 'text/plain',
  })
}
